"use client";
import { Box, Stack } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { Heading } from "@/elements";

const BlogCard = ({ title, image, slug }) => {
  return (
    <Stack
      as="article"
      shadow="xl"
      bg="white"
      p="0.5rem"
      pb="1rem"
      borderRadius="10px"
      border="1px solid #eee"
      transition="box-shadow 0.3s"
      minH="380px"
      display="flex"
      flexDirection="column"
      maxW="360px"
      _hover={{ shadow: "lg" }}
      gap="1.5rem"
    >
      <Box
        position="relative"
        width="100%"
        height="220px"
        borderRadius="8px"
        overflow="hidden"
      >
        <Image
          src={image}
          alt={title}
          fill
          sizes="(min-width: 62em) 360px, 100vw"
          style={{ objectFit: "cover" }}
          placeholder="blur"
          priority={false}
        />
      </Box>
      <Stack
        flex="1"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        px={2}
      >
        <Heading as="h2" variant={"subTitle3"} fontSize="xl">
          {title}
        </Heading>
        <Link
          href={slug}
          aria-label={`Read story: ${title}`}
          style={{
            color: "#021B66",
            textDecoration: "underline",
            textUnderlineOffset: "0.5rem",
            textDecorationThickness: "0.1rem",
            fontWeight: "500",
          }}
        >
          Read Story
        </Link>
      </Stack>
    </Stack>
  );
};

export default BlogCard;
